import React, { useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  StyledText,
  DynamicButton,
  MainHolder,
  Children,
  Body,
} from "../../../../components/common/basic";
import kfcImg from "../../../../components/images/kfcmw.jpg";

import { logEvent } from "firebase/analytics";
import analytics from "../../../../context/analytics";
import RewardItemCard from "../../mashupnwin/components/RewardItemCard";
import {
  AlertModal,
  BackButton,
  FullScreenSelect,
  QuantityControl,
} from "../../../../components/common";
import useReferralWinPickup from "../../referral/hooks/useReferralWinPickup";
import SurveyRewardRedemptionModal from "../components/RewardRedemptionSucessful";

const SurveyReward = () => {
  const history = useHistory();
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MashupAndWinPickup",
        firebase_screen_class: "MashupAndWinPickup",
      })
    );
  }, []);

  const {
    background,
    regionFmt,
    showAlert,
    setShowAlert,
    region,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
    isValidQuantity,
    handleSubmit,
    updatedUserPoints,
  } = useReferralWinPickup();

  return (
    <>
      <MainHolder>
        <BackButton
          onClick={() => {
            history.goBack();
          }}
        />
        <Children>
          <Header>
            <div style={{ textAlign: "center" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium" }}
                margin="0"
              >
                {"Survey rewards"}
              </StyledText>
            </div>
          </Header>
          {
            // TODO: Update success property
            showAlert && (
              <SurveyRewardRedemptionModal
                isOpen={true}
                onClose={() => {
                  setShowAlert(false);
                }}
                label="Congratulations"
                description="You have successfully redeemed GHS 50MB Data to be received within 24hrs. Keep answering questions to accumulate more and redeem them later."
              />
            )
          }
          <Body>
            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <RewardItemCard
                image={kfcImg}
                name="KFC"
                points={"2500 points"}
                showStatus={false}
                color={"red"}
              />
              <hr
                style={{
                  margin: "15px 0",
                  borderTop: "none",
                  borderBottom: "1px solid #ddd",
                }}
              />

              <QuantityControl
                title="Quantity to Redeem"
                value={1}
                setValue={2}
                iconBackground={"red"}
              />

              <div style={{ marginBottom: "150px" }}>
                <StyledText size={18} style={{ fontFamily: "MTNRegular" }}>
                  Pickup from MTN Office{" "}
                </StyledText>
                <FullScreenSelect
                  placeholder="Region"
                  data={regionFmt}
                  selected={region}
                  setValue={setRegion}
                  activeColor={background}
                />
                <FullScreenSelect
                  placeholder="MTN Office"
                  data={officeLocations}
                  selected={officeLocation}
                  setValue={setOfficeLocation}
                  activeColor={background}
                />
              </div>

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px" }}>
                  {updatedUserPoints < 0 && (
                    <StyledText
                      color="red"
                      style={{ textAlign: "center", margin: 0 }}
                    >
                      You do not have enough points to redeem
                    </StyledText>
                  )}
                </div>
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={() => handleSubmit()}
                    label={"Redeem"}
                    disabled={
                      !isValidQuantity ||
                      !region ||
                      updatedUserPoints < 0 ||
                      !officeLocation
                    }
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default SurveyReward;
